export const RoutePostInputsProductImages = "/inputs/product-images";

export interface ImageUploadResult {
  productCode: string;
  status: "SUCCESS" | "ERROR";
  error?: string;
}

export interface ResponsePostInputsProductImages {
  total: number;
  succeeded: number;
  failed: number;
  results: ImageUploadResult[];
}
